import SchemaMarkup from "../Components/SchemaMarkup";

const AboutPageSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",

    "@id": "https://msayurved.com/about-us/#aboutpage",

    "url": "https://msayurved.com/about-us/",

    "name": "About Dr. Jigar Gor | Ayurvedic Doctor in Bhuj",

    "description":
      "Learn about Dr. Jigar Gor, an experienced Ayurvedic consultant in Bhuj, Kutch, Gujarat, and his approach to traditional Ayurvedic healthcare.",

    "isPartOf": {
      "@id": "https://msayurved.com/#website"
    },

    "about": {
      "@id": "https://msayurved.com/#person"
    },

    "mainEntity": {
      "@id": "https://msayurved.com/#person"
    },

    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default AboutPageSchema;